// Transaction cache to reduce API calls
var transactionCache = {};

function formatMoney(amount) {
    return 'RM' + parseFloat(amount || 0).toFixed(2);
}

// Load transaction details via AJAX
function loadTransactionDetails(transactionId) {
    // Show loading, hide content and error
    $('#manual-transfer-loading').show();
    $('#manual-transfer-content').hide();
    $('#manual-transfer-error').hide();

    // Check cache first
    if (transactionCache[transactionId]) {
        renderTransactionDetails(transactionCache[transactionId]);
        return;
    }

    // Replace placeholder with actual ID
    var detailsUrl = ManualTransferConfig.routes.getDetails.replace('_ID_', transactionId);

    // Fetch from server if not in cache
    $.ajax({
        url: detailsUrl,
        type: 'GET',
        dataType: 'json',
        success: function(data) {
            // Store in cache
            transactionCache[transactionId] = data;
            renderTransactionDetails(data);
        },
        error: function(xhr, status, error) {
            var errorMessage = 'Failed to load transaction details';
            if (xhr.responseJSON && xhr.responseJSON.error) {
                errorMessage = xhr.responseJSON.error;
            }

            $('#manual-transfer-error').html(errorMessage).show();
            $('#manual-transfer-loading').hide();
        }
    });
}

// Format transfer date for display
function formatTransferDate(transferDate) {
    if (!transferDate) {
        return 'N/A';
    }

    try {
        var date = new Date(transferDate);
        return date.toLocaleDateString('en-MY', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    } catch (e) {
        return transferDate || 'N/A';
    }
}

// Helper function to create status buttons
function createStatusButton(transaction, statusCode, buttonClass, iconClass, buttonText) {
    return '<button type="button" class="btn btn-sm btn-' + buttonClass + ' mr-2 mb-1 update-status-button" ' +
        'data-transaction-id="' + transaction.id + '" ' +
        'data-transfer-date="' + (transaction.transfer_date || '') + '" ' +
        'data-bank-transfer-type="' + (transaction.bank_transfer_type || '') + '" ' +
        'data-amount="' + (transaction.amount || 0) + '" ' +
        'data-status="' + statusCode + '" ' +
        'data-description="' + (transaction.description || '').replace(/"/g, '&quot;') + '" ' +
        'data-remarks="' + (transaction.remarks || '').replace(/"/g, '&quot;') + '">' +
        '<i class="fal fa-' + iconClass + ' mr-1"></i> ' + buttonText +
        '</button>';
}

// Helper to get button text for status
function getButtonTextForStatus(status) {
    if (status === ManualTransferConfig.statusCodes.successful) {
        return 'Mark as Successful';
    } else if (status === ManualTransferConfig.statusCodes.unsuccessful) {
        return 'Mark as Unsuccessful';
    } else {
        return 'Mark as Pending';
    }
}

// Helper to get button icon for status
function getButtonIconForStatus(status) {
    if (status === ManualTransferConfig.statusCodes.successful) {
        return 'check-circle';
    } else if (status === ManualTransferConfig.statusCodes.unsuccessful) {
        return 'times-circle';
    } else {
        return 'clock';
    }
}

// Render transaction details in the modal
function renderTransactionDetails(transaction) {
    var modal = $('#manualTransferModal');

    // Populate transaction identifiers
    modal.find('#modal-order-no').text(transaction.order_no);
    modal.find('#modal-status').html(ManualTransferConfig.statusLabels[transaction.status] || transaction.status);

    // Build details HTML
    var detailsHtml =
        '<div class="row">' +
        '    <div class="col-5 font-weight-bold">Transaction Date</div>' +
        '    <div class="col-7">' + formatTransferDate(transaction.transfer_date) + '</div>' +
        '</div>' +
        '<div class="row mt-2">' +
        '    <div class="col-5 font-weight-bold">Transfer Type</div>' +
        '    <div class="col-7">' + (transaction.bank_transfer_type || 'N/A') + '</div>' +
        '</div>' +
        '<div class="row mt-2">' +
        '    <div class="col-5 font-weight-bold">Amount</div>' +
        '    <div class="col-7">' + formatMoney(transaction.amount) + '</div>' +
        '</div>' +
        '<div class="row mt-2">' +
        '    <div class="col-5 font-weight-bold">Bank Name</div>' +
        '    <div class="col-7">' + (transaction.merchant_bank_name || 'N/A') + '</div>' +
        '</div>' +
        '<div class="row mt-2">' +
        '    <div class="col-5 font-weight-bold">Bank Account</div>' +
        '    <div class="col-7">' + (transaction.merchant_bank_account || 'N/A') + '</div>' +
        '</div>' +
        '<div class="row mt-2">' +
        '    <div class="col-5 font-weight-bold">Account Holder</div>' +
        '    <div class="col-7">' + (transaction.merchant_bank_account_holder || 'N/A') + '</div>' +
        '</div>';

    // Add notes if available
    if (transaction.transfer_notes) {
        detailsHtml +=
            '<div class="row mt-2">' +
            '    <div class="col-5 font-weight-bold">Notes</div>' +
            '    <div class="col-7">' + transaction.transfer_notes + '</div>' +
            '</div>';
    }

    // Add proof of payment if available
    if (transaction.proof_of_payment) {
        var cleanProof = transaction.proof_of_payment.replace('storage/', '');
        var fileExtension = cleanProof.split('.').pop().toLowerCase();

        if (fileExtension === 'pdf') {
            detailsHtml +=
                '<div class="mt-3">' +
                '    <h6 class="font-weight-bold">Proof of Payment:</h6>' +
                '    <iframe src="' + ManualTransferConfig.fileServiceUrl + cleanProof + '?external_link=' + ManualTransferConfig.hostUrl + '" ' +
                '            width="100%" height="200px" title="Payment Proof PDF"></iframe>' +
                '</div>';
        } else {
            detailsHtml +=
                '<div class="mt-3">' +
                '    <h6 class="font-weight-bold">Proof of Payment:</h6>' +
                '    <div class="text-center">' +
                '        <img class="img-fluid" style="max-height: 200px;" ' +
                '             src="' + ManualTransferConfig.fileServiceUrl + cleanProof + '" ' +
                '             alt="Proof of Payment">' +
                '    </div>' +
                '</div>';
        }
    }

    // Update transaction details container
    $('#transaction-details-container').html(detailsHtml);

    // Set full details link - replace placeholder with actual ID
    var viewDetailsUrl = ManualTransferConfig.routes.viewDetails.replace('_ID_', transaction.id);
    modal.find('#modal-view-details-btn').attr('href', viewDetailsUrl);

    // Populate status action buttons
    var statusButtonsHtml = '';
    var currentStatusStr = String(transaction.status);

    // Add buttons for status change if not the current status
    if (currentStatusStr !== String(ManualTransferConfig.statusCodes.successful)) {
        statusButtonsHtml += createStatusButton(transaction, ManualTransferConfig.statusCodes.successful, 'success', 'check-circle', 'Mark as Successful');
    }

    if (currentStatusStr !== String(ManualTransferConfig.statusCodes.unsuccessful)) {
        statusButtonsHtml += createStatusButton(transaction, ManualTransferConfig.statusCodes.unsuccessful, 'danger', 'times-circle', 'Mark as Unsuccessful');
    }

    if (currentStatusStr !== String(ManualTransferConfig.statusCodes.pending)) {
        statusButtonsHtml += createStatusButton(transaction, ManualTransferConfig.statusCodes.pending, 'warning', 'clock', 'Mark as Pending');
    }

    modal.find('#status-action-buttons').html(statusButtonsHtml);

    // Bind click event to status buttons
    bindStatusButtonEvents();

    // Show content, hide loading
    $('#manual-transfer-loading').hide();
    $('#manual-transfer-content').show();
}

// Bind click events to status update buttons
function bindStatusButtonEvents() {
    $('.update-status-button').off('click').on('click', function() {
        var button = $(this);
        var statusUpdateMessage = $('#status-update-message');

        // Disable button and show loading state
        button.prop('disabled', true);
        button.html('<i class="fal fa-spinner fa-spin mr-1"></i> Updating...');

        // Get transaction data from button attributes
        var transactionId = button.data('transaction-id');
        var newStatus = button.data('status');

        // Prepare form data for status update request
        var formData = {
            _token: ManualTransferConfig.csrfToken,
            transfer_date: button.data('transfer-date'),
            bank_transfer_type: button.data('bank-transfer-type'),
            amount: button.data('amount'),
            status: newStatus,
            description: button.data('description'),
            remarks: button.data('remarks')
        };

        // Get the update URL with the transaction ID
        var updateUrl = ManualTransferConfig.routes.updateStatus.replace('_ID_', transactionId);

        // Function to refresh the DataTable data
        function refreshTableData() {
            // Clear cache to force refresh of transaction details
            delete transactionCache[transactionId];

            // Try different ways to refresh the DataTable based on available objects
            if (typeof LaravelDataTables !== 'undefined' && LaravelDataTables['transactions-table']) {
                LaravelDataTables['transactions-table'].ajax.reload(null, false);
                return true;
            } else if ($('#transactions-table').length) {
                try {
                    $('#transactions-table').DataTable().ajax.reload(null, false);
                    return true;
                } catch (e) {
                    // Failed to refresh via DOM selector
                }
            }
            return false;
        }

        // Submit update via AJAX
        $.ajax({
            url: updateUrl,
            type: 'POST',
            data: formData,
            beforeSend: function() {
                // Pre-request initialization if needed
            },
            success: function(response) {
                // Show success message
                statusUpdateMessage
                    .removeClass('alert-danger')
                    .addClass('alert-success')
                    .html('<i class="fal fa-check-circle mr-1"></i> Status updated successfully!')
                    .show();

                // Update summary if the function exists
                if (typeof refreshSummary === 'function') {
                    try {
                        refreshSummary();
                    } catch (e) {
                        // Error handling for summary refresh
                    }
                }

                // Refresh the table data immediately
                refreshTableData();

                // Close modal after a short delay
                setTimeout(function() {
                    $('#manualTransferModal').modal('hide');
                }, 1000);
            },
            error: function(xhr, status, error) {
                // Check if we received HTML (usually a redirect)
                if (xhr.responseText && xhr.responseText.indexOf('<!DOCTYPE html>') === 0) {
                    // Handle HTML response as success
                    statusUpdateMessage
                        .removeClass('alert-danger')
                        .addClass('alert-success')
                        .html('<i class="fal fa-check-circle mr-1"></i> Status updated successfully!')
                        .show();

                    // Try to refresh the DataTable
                    refreshTableData();

                    // Refresh summary if available
                    if (typeof refreshSummary === 'function') {
                        try {
                            refreshSummary();
                        } catch (e) {
                            // Error handling for summary refresh
                        }
                    }

                    // Close modal after a short delay
                    setTimeout(function() {
                        $('#manualTransferModal').modal('hide');
                    }, 1000);

                    return;
                }

                // Handle error responses
                var errorMessage = 'An error occurred while updating the status.';
                if (xhr.responseJSON && xhr.responseJSON.message) {
                    errorMessage = xhr.responseJSON.message;
                } else if (xhr.responseJSON && xhr.responseJSON.errors) {
                    errorMessage = Object.values(xhr.responseJSON.errors).flat().join('<br>');
                }

                // Display error message to user
                statusUpdateMessage
                    .removeClass('alert-success')
                    .addClass('alert-danger')
                    .html('<i class="fal fa-exclamation-circle mr-1"></i> ' + errorMessage)
                    .show();

                // Reset button to original state
                var buttonText = getButtonTextForStatus(newStatus);
                var buttonIcon = getButtonIconForStatus(newStatus);
                button.html('<i class="fal fa-' + buttonIcon + ' mr-1"></i> ' + buttonText);
            },
            complete: function() {
                // Re-enable button regardless of outcome
                button.prop('disabled', false);
            }
        });
    });
}

// Initialize modal behavior on document ready
$(document).ready(function() {
    $('#manualTransferModal').on('show.bs.modal', function(event) {
        var button = $(event.relatedTarget);
        var transactionId = button.data('transaction-id');

        if (!transactionId) {
            $('#manual-transfer-error').html('Transaction ID not provided').show();
            $('#manual-transfer-loading').hide();
            return;
        }

        // Reset modal state
        $('#status-update-message').hide().removeClass('alert-success alert-danger');

        // Load transaction details
        loadTransactionDetails(transactionId);
    });
});